const piAfEventReaderEn = {
	piAfEventReaderEditForm: 'PI AF Event Reader',
	piAfEventReaderTable: 'PI AF Event Reader',
	name: 'Name',
	piConnection: 'PI Connection',
	'piConnection.name': 'PI Connection',
	database: 'Database',
	templateName: 'Template Name',
	start_date_time: 'Start date',
	end_date_time: 'End date'
};

export default piAfEventReaderEn;
